module.exports = __webpack_public_path__ + "img/Group 305one2.55e48be9.svg";